export const ANALYTICS_OVERVIEW = 'ANALYTICS_OVERVIEW'
export const ANALYTICS_ACTIVE_USERS = 'ANALYTICS_ACTIVE_USERS'
export const ANALYTICS_SNAPSHOT = 'ANALYTICS_SNAPSHOT'
export const POST_ENGAGEMENT_OVERVIEW = 'POST_ENGAGEMENT_OVERVIEW'
export const POST_ENGAGEMENT_TOP_POSTS = 'POST_ENGAGEMENT_TOP_POSTS'
export const POST_ENGAGEMENT_VIEWS_SERIES = 'POST_ENGAGEMENT_VIEWS_SERIES'
